import type { ReadonlyNonEmptyArray } from '../../../../../../utils'

import { areCybusEndpointEquals, Capability, type StatusType } from '../../../../../../domain'

import type { PageSubscriptionsTypes, SubscriptionFilterArgs } from '../../../../../../application'

import type { Resource } from '../../../../mappers'
import {
    type AllResourcesRequestConfig,
    BaseStatefulPageResourceSubscriptionStrategy,
    type PageResourceQueryParameters,
    type PageResourceSortableColumnsMap,
    type ServiceResourcesRequestConfig,
} from '../Resource'
import { mapBaseEndpoint } from './Base'

export class EndpointsStrategy extends BaseStatefulPageResourceSubscriptionStrategy<'Endpoint', 'endpoints'> {
    protected override readonly supportedFilters: (keyof SubscriptionFilterArgs)[] = ['service', 'connection']

    protected override readonly areEquals = areCybusEndpointEquals

    protected readonly serviceResourcesRequestConfig: ServiceResourcesRequestConfig<'endpoints'> = {
        capability: Capability.ENDPOINTS_READ,
        path: '/api/v2/services/+/resources',
        method: 'GET',
    }

    protected override readonly allResourcesRequestConfig: AllResourcesRequestConfig<'endpoints'> = {
        capability: Capability.ENDPOINTS_READ,
        path: '/api/v2/resources',
        method: 'GET',
    }

    protected override readonly resourceCategories: ReadonlyNonEmptyArray<'Endpoint'> = ['Endpoint']

    protected override readonly resourceStatusType = 'endpoints' as const

    protected override readonly serviceDeviationsType = ['endpoints', 'endpoints'] as const

    protected override readonly serverErrorMessage = 'Could not fetch endpoints'

    protected sortingColumns: PageResourceSortableColumnsMap<'endpoints'> = {
        agent: 'runnerName',
        connection: 'parentResourceId',
        id: 'resourceId',
        name: 'resourceName',
        operation: null,
        protocol: 'protocol',
        service: 'serviceId',
        status: null,
    }

    override readonly requiredPermissions = [Capability.ENDPOINTS_READ]

    protected override mapResource (resource: Resource<'Endpoint'>, status: StatusType): PageSubscriptionsTypes['endpoints'] {
        return { ...mapBaseEndpoint(resource), connection: resource.parentResourceId, status }
    }

    protected override createCustomQueryParameters ({ connection }: SubscriptionFilterArgs): PageResourceQueryParameters {
        return connection ? { parentResourceId: connection } : {}
    }
}
